module.exports = __webpack_public_path__ + "img/versoStatement.03649b79.jpg";